import _ from "lodash";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import { getCurrentUser, getFullName } from "../../utils/utils";
import { Roles } from "../../utils/constants";
import AvailabilityHoursUpdate from "./AvailabilityHoursUpdate";
import AppModal from "../../components/Modal";

const AvailabilityModal = ({ open, onClose, request, setRequests }) => {
  const user = getCurrentUser();

  const columns = [
    {
      label: "Category",
      name: "category.name",
    },
    {
      label: "Available Hours",
      name: "hours",
      component: (item) => {
        if (user.role === Roles.EMPLOYEE.value) {
          return (
            <AvailabilityHoursUpdate
              setRequests={setRequests}
              availabilityId={item.id}
              hours={item.hours}
              onClose={onClose}
            />
          );
        } else {
          return item.hours;
        }
      },
    },
    // {
    //   label: "Note",
    //   name: "note",
    // },
  ];

  return (
    request && (
      <AppModal
        open={open}
        onClose={onClose}
        title={`Availability for ${
          user.role === Roles.EMPLOYER.value ? "employee" : "employer"
        } ${getFullName(request.user)}`}
      >
        <Container>
          {request.availabilities.map((i) => (
            <Row key={i}>
              {columns.map((col) => {
                let data = _.get(i, col.name);
                if (col?.component) {
                  data = col.component(i);
                }

                return (
                  <span key={col.name}>
                    <span style={{ fontWeight: "bold" }}>{col.label} </span>-{" "}
                    {data}
                  </span>
                );
              })}
              <hr />
            </Row>
          ))}
        </Container>
      </AppModal>
    )
  );
};

export default AvailabilityModal;
